"use client";

import { ArrowLeft, Home, RefreshCcw } from "lucide-react";
import Link from "next/link";
import { useRouter } from "next/navigation";

export default function NotFound(): React.JSX.Element {
  const router = useRouter();

  return (
    <div
      role="region"
      aria-labelledby="not-found-heading"
      className="min-h-[60vh] flex items-center justify-center bg-gradient-to-b from-gray-50 to-gray-100"
    >
      <div className="max-w-2xl mx-auto px-4">
        <div className="text-center space-y-8 p-8 bg-white rounded-2xl shadow-xl">
          {/* Animated 404 Text */}
          <div className="relative">
            <p className="text-8xl font-bold text-gray-900 animate-bounce" aria-hidden="true">
              404
            </p>
            <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-16 h-1 bg-indigo-600 rounded-full" />
          </div>

          <h1 id="not-found-heading" className="text-3xl font-semibold text-gray-800">
            Oops! Page Not Found
          </h1>

          <p className="text-gray-600 max-w-md mx-auto">
            The page you are looking for might have been removed, had its name
            changed, or is temporarily unavailable.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => router.back()}
              className="flex items-center justify-center gap-2 px-6 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
            >
              <ArrowLeft size={20} />
              Go Back
            </button>

            <Link
              href="/"
              className="flex items-center justify-center gap-2 px-6 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
            >
              <Home size={20} />
              Return Home
            </Link>

            <button
              onClick={() => window.location.reload()}
              className="flex items-center justify-center gap-2 px-6 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
            >
              <RefreshCcw size={20} />
              Reload Page
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
